import AuthService from './auth-service';
import axios from 'axios';
import config from '@/config';

export default async () => {
  const token = await AuthService.token();

  return axios.create({
    baseURL: config.SERVER_URL,
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
};
